<!--
 * @Description: description
 * @Author: chenguobiao
 * @Date: 2021-09-23 19:52:51
 * @LastEditTime: 2022-11-12 21:47:14
 * @LastEditors: chenguobiao
-->
<template>
  <div class="register-page page-normal">
    <common-header selected="user" />
    <div class="register-page__content page-normal__content">
      <div
        class="register-page__register-box flex"
        v-if="[0, 1].includes(registerStep)"
      >
        <div class="register-box__left">
          <div class="title">
            <div class="left-main"><span class="line-bar"></span>注册信息</div>
            <div class="right-back" @click="handleBack">返回登录</div>
          </div>
          <el-form
            :model="formData"
            :rules="rules"
            ref="formRef"
            label-position="top"
          >
            <div class="register-step" v-show="registerStep === 0">
              <div class="form-item-row">
                <el-form-item label="头像" class="avatar-form-item">
                  <upload-img
                    v-model="formData.avatarUrl"
                    :url="formData.avatarUrl"
                  />
                </el-form-item>
                <el-form-item label="账号" prop="loginName">
                  <el-input
                    v-model.trim="formData.loginName"
                    placeholder="请输入账号"
                    autocomplete="off"
                    @blur="checkLoginName"
                  />
                </el-form-item>
                <el-form-item label="密码" prop="password" class="password">
                  <el-input
                    type="password"
                    maxlength="16"
                    autocomplete="new-password"
                    placeholder="请输入密码"
                    v-model.trim="formData.password"
                  ></el-input>
                  <span
                    class="security-level"
                    ref="tip"
                    style="display: none; color: #666"
                    ><span ref="level"></span
                  ></span>
                </el-form-item>
              </div>
              <div class="form-item-row">
                <el-form-item label="真实姓名" prop="name">
                  <el-input
                    v-model.trim="formData.name"
                    placeholder="请输入真实姓名"
                  />
                </el-form-item>
                <el-form-item label="性别" prop="sex">
                  <el-select v-model="formData.sex" placeholder="请选择性别">
                    <el-option label="男" :value="1" />
                    <el-option label="女" :value="0" />
                  </el-select>
                </el-form-item>
                <el-form-item label="所在地区" prop="cascaderCity">
                  <china-area
                    v-model="formData.cascaderCity"
                    @change="handleChangeArea"
                  />
                </el-form-item>
              </div>
              <div class="form-item-row">
                <el-form-item label="证件类型" prop="cardTypeUid">
                  <el-select
                    v-model="formData.cardTypeUid"
                    @change="handleIdentityChange"
                    placeholder="请选择证件类型"
                  >
                    <el-option
                      v-for="identity in identityList"
                      :key="identity.uid"
                      :label="identity.name"
                      :value="identity.uid"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item label="证件号码" prop="card">
                  <el-input
                    v-model.trim="formData.card"
                    placeholder="请输入证件号码"
                    autocomplete="off"
                  />
                </el-form-item>
                <el-form-item label="生日日期" prop="age">
                  <el-date-picker
                    v-model="formData.age"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="请选择生日"
                  />
                </el-form-item>
              </div>
              <div class="form-item-row" style="align-items: center;">
                <div class="form-item-col">
                  <div class="form-item-row attachment">
                    <el-form-item class="no--border" required>
                      <label slot="label">
                        证件照片
                        <el-tooltip
                          effect="dark"
                          placement="right"
                        >
                          <div slot="content">可上传身份证照片正反面或户口本个人信息页，<br/>仅支持图片，格式为png、jpg、jpeg，<br/>大小限制5M</div>
                          <div class="icon-question">
                            <img
                              src="@/render/assets/images/auth/icon-question.png"
                            />
                          </div>
                        </el-tooltip>
                      </label>
                      <div class="upload--attachment--list">
                        <upload-attachment
                          v-model="formData.picUrls[0]"
                          :url="formData.picUrls[0]"
                          type="idCard"
                        />
                        <upload-attachment
                          v-model="formData.picUrls[1]"
                          :url="formData.picUrls[1]"
                          type="idCard"
                        />
                      </div>
                    </el-form-item>
                  </div>
                </div>
                <div class="form-item-col">
                  <div class="form-item-row">
                    <el-form-item label="家长姓名" prop="parentName">
                      <el-input
                        v-model="formData.parentName"
                        placeholder="成人考生可填写本人姓名"
                      />
                    </el-form-item>
                    <el-form-item label="与选手关系" prop="relation">
                      <el-select
                        v-model="formData.relation"
                        placeholder="请选择与选手关系"
                      >
                        <el-option
                          v-for="relation in relationList"
                          :key="relation.uid"
                          :label="relation.name"
                          :value="relation.name"
                        />
                      </el-select>
                    </el-form-item>
                  </div>
                  <div class="form-item-row">
                    <el-form-item
                      label="家长手机号"
                      prop="parentPhone"
                      class="mobile"
                    >
                      <el-input
                        v-model="formData.parentPhone"
                        placeholder="成人考生可填写本人手机号"
                        autocomplete="off"
                      />
                      <div class="send-message" @click="handleClickSendMessage">
                        {{
                          countDownTimes === 0 ? '获取验证码' : countDownTimes + 's'
                        }}
                      </div>
                    </el-form-item>
                    <el-form-item label="短信验证码" prop="code">
                      <el-input v-model="formData.code"></el-input>
                    </el-form-item>
                  </div>
                </div>
              </div>
              <div class="form-item-row operation first-step">
                <div
                  class="change-step"
                  @click="handleClickChangeStep('increase')"
                >
                  填写棋力信息<span class="icon-back"></span>
                </div>
              </div>
            </div>
            <div class="register-step" v-show="registerStep === 1">
              <div class="form-item-row">
                <el-form-item label="学棋始于日期" prop="studyTime">
                  <el-date-picker
                    v-model="formData.studyTime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="请选择学棋始于日期"
                  />
                </el-form-item>
                <el-form-item label="在读学校" class="club" prop="clubUid">
                  <el-select
                    v-model="formData.clubUid"
                    filterable
                    reserve-keyword
                    placeholder="请选择在读学校"
                    @change="handleChangeClub"
                  >
                    <template v-for="unit in unitList">
                      <el-option
                        v-if="unit"
                        :label="unit.unitName"
                        :value="unit.uid"
                        :key="unit.uid"
                      />
                    </template>
                  </el-select>
                </el-form-item>
                <el-form-item label="在训机构" prop="organizationUid">
                  <el-select
                    v-model="formData.organizationUid"
                    filterable
                    reserve-keyword
                    placeholder="请选择在训机构名称"
                    @change="handleChangeOrganization"
                  >
                    <el-option
                      v-for="organization in organizationList"
                      :label="organization.organizationName"
                      :value="organization.uid"
                      :key="organization.uid"
                    />
                  </el-select>
                </el-form-item>
              </div>
              <div
                class="form-item-row attachment"
              >
                <el-form-item
                  class="attachment--certificate no--border"
                  label="是否有考级证书"
                  prop="certificateState"
                >
                  <label class="diy--label" slot="label">
                    <div class="diy--label--text">是否有考级证书</div>
                    <el-tooltip
                      effect="dark"
                      placement="right"
                    >
                      <div slot="content">若有考级证书，可上传已获<br/>考级证书原件图片,平台将<br/>根据考级证书同步你当前国<br/>际象棋棋力等级，文件大小<br/>限制5M。</div>
                      <div class="icon-question">
                        <img
                          src="@/render/assets/images/auth/icon-question.png"
                        />
                      </div>
                    </el-tooltip>
                  </label>
                  <div style="display:flex;align-items:center;">
                    <el-radio v-model="formData.certificateState" :label="1">是</el-radio>
                    <el-radio v-model="formData.certificateState" :label="2">否</el-radio>
                  </div>
                </el-form-item>
                <el-form-item label="对应申请等级" prop="levelUid" v-if="formData.certificateState === 1" required>
                  <el-select
                    v-model="formData.levelUid"
                    @change="handleGradeChange"
                    placeholder="请选择证书等级"
                  >
                    <el-option
                      v-for="grade in gradeList"
                      :key="grade.uid"
                      :label="grade.showName"
                      :value="grade.uid"
                    />
                  </el-select>
                </el-form-item>
              </div>
              <div class="form-item-row attachment">
                <el-form-item class="no--border attachment--certificate--upload" v-if="formData.certificateState === 1" required>
                  <label slot="label">
                    上传棋力证书
                    <el-tooltip
                      effect="dark"
                      content="请上传国际象棋棋力认证证书原件相关证明图片，文件大小限制5M"
                      placement="right"
                    >
                      <div slot="content">请上传国际象棋棋力认证<br/>证书原件相关证明图片，<br/>文件大小限制5M</div>
                      <div class="icon-question">
                        <img
                          src="@/render/assets/images/auth/icon-question.png"
                        />
                      </div>
                    </el-tooltip>
                  </label>
                  <div class="upload--attachment--list">
                    <upload-attachment
                      v-model="formData.certificatePicUrl[0]"
                      :url="formData.certificatePicUrl[0]"
                      type="certificate"
                    />
                    <upload-attachment
                      v-model="formData.certificatePicUrl[1]"
                      :url="formData.certificatePicUrl[1]"
                      type="certificate"
                    />
                  </div>
                </el-form-item>
              </div>
              <div class="form-item-row operation second-step">
                <div
                  class="change-step"
                  @click="handleClickChangeStep('reduce')"
                >
                  返回上一页<span class="icon-back rotate"></span>
                </div>
              </div>
              <div class="form-item-row button">
                <div class="register-button" @click="handleClickRegister">
                  <img
                    src="@/render/assets/images/auth/register-button.png"
                    v-if="agreementFlag"
                  />
                  <img
                    src="@/render/assets/images/auth/register-button-disabled.png"
                    v-else
                  />
                </div>
              </div>
              <div class="form-item-row agreement">
                <div class="agreement-text">
                  注册代表您已经阅读并同意<span @click="handleClickAgreement"
                    >《国际象棋赛事用户协议》</span
                  >
                </div>
              </div>
            </div>
          </el-form>
        </div>
        <div class="register-box__right">
          <img :src="require(`@/render/assets/images/auth/register-right-bg-${registerStep === 0 ? 'first' : 'second'}.png`)" />
        </div>
      </div>
      <div class="register-page__register-result" v-else>
        <div class="title">
          <div class="left-main"><span class="line-bar"></span>注册信息</div>
        </div>
        <div class="register-result-main">
          <div v-if="registerState === 2" class="success">
            <div class="image-wrap">
              <img src="@/render/assets/images/auth/register-success.png" />
            </div>
            <div class="desc">恭喜您注册成功！</div>
            <div class="options">
              <div class="back--login" @click="handleBack">去登录 >></div>
            </div>
          </div>
          <div v-else-if="registerState === 1" class="wait">
            <div class="image-wrap">
              <img src="@/render/assets/images/auth/register-wait.png" />
            </div>
            <div class="desc">
              您已成功向平台发送注册申请，后台正在审核，<br />请耐心等待1~3个工作日，结果将以短信告知！
            </div>
            <div class="options">
              <div class="back--login" @click="handleBack">返回登录</div>
            </div>
          </div>
          <!-- <div v-else class="fail">
            <div class="image-wrap">
              <img src="@/render/assets/images/auth/register-fail.png">
            </div>
            <div class="desc">注册失败</div>
            <div class="options">
              <div class="option" @click="handleAgainRegister">重新注册</div>
              <div class="option" @click="handleBack">返回登录</div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    <agreement ref="agreementRef" />
  </div>
</template>

<script>
import _ from 'lodash'
import CryptoJS from 'crypto-js'
import { authAPI } from '@/apis'
import CommonHeader from '@/render/components/common/header'
// import CityCascader from '@/render/components/common/city-cascader'
import uploadImg from '@/render/components/common/uploadImg'
import chinaArea from '@/render/components/common/china-area'
import uploadAttachment from '../components/uploadAttachment'
import agreement from '../components/agreement'
import { deepClone, Timer } from '@/render/utils'
import { COUNTDOWN } from '@/config/const'
let timer = null
export default {
  name: 'RegisterPage',
  data() {
    const validate = {
      PASSOWRD_REG_WEEK: /^[0-9]{6,8}$|^[A-Z]{6,8}$|^[a-z]{6,8}$|^[\W_!@#$%^&*`~()-+=]{6,8}$/,
      // eslint-disable-next-line no-control-regex
      PASSOWRD_REG_MIDDLE: /^(?!\d+$)(?![a-zA-Z]+$)[\da-zA-Z]{8,10}$|^(?!\d+$)(?![\x00-\xff]+$)[\d\x00-\xff]{8,10}$|^(?!a-zA-Z+$)(?![\x00-\xff]+$)[a-zA-Z\x00-\xff]{8,10}$/,
      PASSOWRD_REG_POWER: /^(?=.*[a-zA-Z])(?=.*[\W_!@#$%^&*`~()-+=])(?=.*\d)[^]{10,16}$|^(?=.*[a-zA-Z])(?=.*[\W_!@#$%^&*`~()-+=])[^]{10,16}$|^(?=.*\d)(?=.*[\W_!@#$%^&*`~()-+=])[^]{10,16}$|^(?=.*[a-zA-Z])(?=.*\d)[^]{10,16}$/,
    }
    const validatePassword = (rule, value, callback) => {
      if (value.length < 6 || value.length > 16) {
        this.$refs.tip.style.display = 'none'
        callback(new Error('密码位数为6位 ~ 16位'))
      } else if (value === '') {
        callback(new Error('请输入新密码'))
      } else if (validate.PASSOWRD_REG_WEEK.test(value)) {
        this.$refs.level.innerText = '弱，建议加强'
        this.$refs.tip.style.display = 'block'
        callback()
      } else if (validate.PASSOWRD_REG_MIDDLE.test(value)) {
        this.$refs.level.innerText = '中'
        this.$refs.tip.style.display = 'block'
        callback()
      } else if (validate.PASSOWRD_REG_POWER.test(value)) {
        this.$refs.level.innerText = '强'
        this.$refs.tip.style.display = 'block'
        callback()
      }
    }
    const validateMobile = (rule, value, callback) => {
      if (!value) {
        return new Error('请输入电话号码')
      } else {
        const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
        const isPhone = reg.test(value)
        value = Number(value) // 转换为数字
        if (typeof value === 'number' && !isNaN(value)) {
          // 判断是否为数字
          value = value.toString() // 转换成字符串
          if (value.length < 0 || value.length > 12 || !isPhone) {
            // 判断是否为11位手机号
            callback(new Error('手机号码格式如:138xxxx8754'))
          } else {
            callback()
          }
        } else {
          callback(new Error('请输入电话号码'))
        }
      }
    }
    const idCardValidity = (rule, code, callback) => {
      var city = {
        11: '北京',
        12: '天津',
        13: '河北',
        14: '山西',
        15: '内蒙古',
        21: '辽宁',
        22: '吉林',
        23: '黑龙江 ',
        31: '上海',
        32: '江苏',
        33: '浙江',
        34: '安徽',
        35: '福建',
        36: '江西',
        37: '山东',
        41: '河南',
        42: '湖北 ',
        43: '湖南',
        44: '广东',
        45: '广西',
        46: '海南',
        50: '重庆',
        51: '四川',
        52: '贵州',
        53: '云南',
        54: '西藏 ',
        61: '陕西',
        62: '甘肃',
        63: '青海',
        64: '宁夏',
        65: '新疆',
        71: '台湾',
        81: '香港',
        82: '澳门',
        91: '国外',
      }
      var tip = ''
      var pass = true

      if (
        !code ||
        !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(
          code,
        )
      ) {
        tip = '身份证号格式错误'
        pass = false
      } else if (!city[code.substr(0, 2)]) {
        tip = '地址编码错误'
        pass = false
      } else {
        // 18位身份证需要验证最后一位校验位
        if (code.length === 18) {
          code = code.split('')
          // ∑(ai×Wi)(mod 11)
          // 加权因子
          var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
          // 校验位
          var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]
          var sum = 0
          var ai = 0
          var wi = 0
          for (var i = 0; i < 17; i++) {
            ai = code[i]
            wi = factor[i]
            sum += ai * wi
          }
          var last = parity[sum % 11]
          if (parity[sum % 11] != code[17]) {
            tip = '校验位错误'
            pass = false
          }
        }
      }
      if (!pass) {
        callback(new Error(tip))
      } else {
        callback()
      }
      // if (!pass) alert(tip)
      // return pass
    }
    return {
      agreementFlag: false,
      formData: {
        name: '', // 名称
        avatarUrl: '', // 头像
        sex: '', // 0女 1男
        age: '', // 年龄
        cardTypeUid: '', // 身份类型uid 字典
        cardTypeName: '', // 身份类型名称
        card: '', // 身份证号码
        clubName: '', // 俱乐部（学校）
        studyTime: '', // 学习时间 “2020-05-02”
        parentName: '', // 家长
        relation: '', // 家长关系
        parentPhone: '', // 家长联系方式
        provinceUid: '', // 省
        cityUid: '', // 市
        areaUid: '', // 区
        cascaderCity: '', // 联合省市区
        loginName: '', // 登录名
        password: '', // 密码
        code: '', // 验证码
        picUrls: ['', ''],
        certificateState: '', // 是否有考核证书状态 1：是 2：否 （默认为否）
        certificateUrl: '', // 考核证书状态为是后，该字段必填
        certificatePicUrl: ['', ''],
        clubUid: '', // 俱乐部单位的uid（下拉）
        levelUid: '',
        levelName: '',
        organizationUid: '', // 机构的uid
        organizationName: '', // 机构名称

        // "name": "陈某",
        // "avatarUrl": "http://test.zjhzxinzhihui.com/upload/2024-08-07/20240807_203344928.png",
        // "sex": 1,
        // "age": "1993-01-08",
        // "cardTypeUid": "12530ae8818b4d2bdb20b8cb38040fd4",
        // "cardTypeName": "中国身份证（包含港澳台）",
        // "card": "342626199301084576",
        // "clubName": "杭州市祥符艺术幼儿园",
        // "studyTime": "2024-08-05",
        // "parentName": "陈某某",
        // "relation": "父子",
        // "parentPhone": "17887241862",
        // "provinceUid": "",
        // "cityUid": "",
        // "areaUid": "",
        // "cascaderCity": "北京市|市辖区|东城区",
        // "loginName": "chen2024",
        // "password": "1qaz@WSX",
        // "code": "022275",
        // "picUrls": [
        //     "http://test.zjhzxinzhihui.com/upload/2024-08-07/20240807_204046171.png",
        //     "http://test.zjhzxinzhihui.com/upload/2024-08-07/20240807_204048212.png"
        // ],
        // "certificateState": 2,
        // "certificateUrl": "",
        // "certificatePicUrl": [
        //     "",
        //     ""
        // ],
        // "clubUid": "016f09e72aa8ad3790abbce0785d5edd",
        // "levelUid": "",
        // "levelName": "",
        // "organizationUid": "044c6cbb2aea1846ef2aac5a63056317",
        // "organizationName": "鑫棋道"
      },
      rules: {
        name: [{ required: true, message: '请输入真实姓名', trigger: 'blur' }],
        sex: [{ required: true, message: '请选择性别', trigger: 'change' }],
        age: [{ required: true, message: '请输入生日日期', trigger: 'blur' }],
        cardTypeUid: [
          { required: true, message: '请选择证件类型', trigger: 'change' },
        ],
        card: [
          { required: true, message: '请输入证件号码', trigger: 'blur' },
          {
            pattern: /(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0\d|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/,
            message: '请输入正确的证件号',
          },
          { validator: idCardValidity, trigger: 'blur' },
        ],
        levelUid: [
          { required: true, message: '请选择对应申请等级', trigger: 'change' },
        ],
        clubUid: [
          { required: true, message: '请选择在读学校', trigger: 'change' },
        ],
        studyTime: [
          { required: true, message: '请输入学习时间', trigger: 'blur' },
        ],
        parentName: [
          { required: true, message: '请输入家长姓名', trigger: 'blur' },
        ],
        relation: [
          { required: true, message: '请选择与选手关系', trigger: 'change' },
        ],
        parentPhone: [
          { required: true, message: '请输入家长手机号', trigger: 'blur' },
          { validator: validateMobile, trigger: 'blur' },
        ],
        cascaderCity: [
          { required: true, message: '请选择所在地区', trigger: 'blur' },
        ],
        loginName: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { validator: validatePassword },
        ],
        code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
        organizationUid: [
          { required: true, message: '请选择机构', trigger: 'change' },
        ],
        certificateState: [
          { required: true, message: '请选择是否有考级证书', trigger: 'change' },
        ],
      },
      identityList: [],
      idCardUid: '',
      relationList: [],
      unitList: [], // 单位列表
      organizationList: [], // 机构列表
      countDownTimes: 0,
      registerStep: 0,
      registerState: 2, // 0失败，1等待 2成功
      gradeList: [], // 考级等级列表
    }
  },
  watch: {
    'formData.card': function(card) {
      this.$refs.formRef.validateField('card', async errorMessage => {
        if (errorMessage === '') {
          this.generateBirth(card)
        } else {
          this.formData.age = ''
        }
      })
    },
  },
  components: {
    CommonHeader,
    uploadImg,
    chinaArea,
    uploadAttachment,
    agreement,
  },
  destroyed() {
    timer && timer.stop()
  },
  mounted() {
    this.getIdentityList()
    this.getRelationList()
    this.getGradeList()
    this.getUnitList()
    this.getOrganizationList()
  },
  methods: {
    generateBirth(customercode) {
      if (this.formData.cardTypeUid === this.idCardUid) {
        this.formData.age =
          customercode.substring(6, 10) +
          '-' +
          customercode.substring(10, 12) +
          '-' +
          customercode.substring(12, 14)
      }
    },
    handleChangeArea(value) {
      console.log('value', value)
    },
    handleChangeClub(clubUid) {
      const club = this.unitList.find(ele => ele.uid === clubUid)
      this.formData.clubName = club.unitName
    },
    handleChangeOrganization(organizationUid) {
      const organization = this.organizationList.find(
        ele => ele.uid === organizationUid,
      )
      this.formData.organizationName = organization.organizationName
    },
    async checkLoginName() {
      if (this.formData.loginName) {
        try {
          await authAPI.postCheckLoginName({
            loginName: this.formData.loginName,
          })
        } catch (error) {
          throw error
        }
      }
    },
    handleIdentityChange(value) {
      const findIdentity = this.identityList.find(
        identity => identity.uid === value,
      )
      this.formData.cardTypeName = findIdentity.name
      if (value === this.idCardUid) {
        const idCardValidity = (rule, code, callback) => {
          var city = {
            11: '北京',
            12: '天津',
            13: '河北',
            14: '山西',
            15: '内蒙古',
            21: '辽宁',
            22: '吉林',
            23: '黑龙江 ',
            31: '上海',
            32: '江苏',
            33: '浙江',
            34: '安徽',
            35: '福建',
            36: '江西',
            37: '山东',
            41: '河南',
            42: '湖北 ',
            43: '湖南',
            44: '广东',
            45: '广西',
            46: '海南',
            50: '重庆',
            51: '四川',
            52: '贵州',
            53: '云南',
            54: '西藏 ',
            61: '陕西',
            62: '甘肃',
            63: '青海',
            64: '宁夏',
            65: '新疆',
            71: '台湾',
            81: '香港',
            82: '澳门',
            91: '国外 ',
          }
          var tip = ''
          var pass = true

          if (
            !code ||
            !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(
              code,
            )
          ) {
            tip = '身份证号格式错误'
            pass = false
          } else if (!city[code.substr(0, 2)]) {
            tip = '地址编码错误'
            pass = false
          } else {
            // 18位身份证需要验证最后一位校验位
            if (code.length === 18) {
              code = code.split('')
              // ∑(ai×Wi)(mod 11)
              // 加权因子
              var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
              // 校验位
              var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]
              var sum = 0
              var ai = 0
              var wi = 0
              for (var i = 0; i < 17; i++) {
                ai = code[i]
                wi = factor[i]
                sum += ai * wi
              }
              var last = parity[sum % 11]
              if (parity[sum % 11] != code[17]) {
                tip = '校验位错误'
                pass = false
              }
            }
          }
          if (!pass) {
            callback(new Error(tip))
          } else {
            callback()
          }
          // if (!pass) alert(tip)
          // return pass
        }
        this.rules.card = [
          { required: true, message: '请输入证件号码', trigger: 'blur' },
          {
            pattern: /(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0\d|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/,
            message: '请输入正确的证件号',
          },
          { validator: idCardValidity, trigger: 'blur' },
        ]
      } else {
        this.rules.card = [
          { required: true, message: '请输入证件号码', trigger: 'blur' },
          // {
          //   pattern:
          //     /(^1[45][0-9]{7}|([P|p|S|s]\d{7})|([S|s|G|g]\d{8})|([Gg|Tt|Ss|Ll|Qq|Dd|Aa|Ff]\d{8})|([H|h|M|m]\d{8，10})$)/,
          //   message: '请输入正确的护照号',
          // },
        ]
      }
    },
    handleGradeChange(value) {
      const idx = this.gradeList.findIndex(grade => grade.uid === value)
      Object.assign(this.formData, {
        levelUid: this.gradeList[idx].uid,
        levelName: this.gradeList[idx].name,
      })
    },
    handleBack() {
      this.$router.replace('/login')
    },
    async getIdentityList() {
      const result = await authAPI.postGetListByCode({ code: 'certificates' })
      this.identityList = result.data
      const idx =
        this.identityList.findIndex(ele => ele.name.indexOf('身份证') > -1) || 0
      this.formData.cardTypeUid = this.identityList[idx].uid
      this.formData.cardTypeName = this.identityList[idx].name
      this.idCardUid = this.identityList[idx].uid
    },
    async getRelationList() {
      const result = await authAPI.postGetListByCode({ code: 'relation' })
      this.relationList = result.data
    },
    async getGradeList() {
      const result = await authAPI.postGetListByCode({
        code: 'test-grade',
        field: 'sort',
      })
      const gradeList = result.data.sort((prev, next) => {
        return next.name - prev.name
      })
      this.gradeList = gradeList.map(grade => {
        if (grade.name === '16') {
          grade.showName = '无等级'
          // this.formData.levelUid = grade.uid
          // this.formData.levelName = grade.name
        } else {
          grade.showName = `国际象棋${grade.name}级`
        }
        return grade
      })
    },
    async getOrganizationList() {
      const result = await authAPI.postGetOrganizationList({
        organizationName: '',
      })
      this.organizationList = result.data
    },
    async getUnitList() {
      const result = await authAPI.postGetUnitList({
        unitName: '',
      })
      this.unitList = result.data
    },
    handleAgainRegister() {
      this.$router.go(0)
    },
    handleClickSendMessage() {
      if (this.countDownTimes !== 0) return false
      this.$refs.formRef.validateField('parentPhone', async errorMessage => {
        if (errorMessage === '') {
          try {
            await authAPI.postSendSmsCode({
              phone: this.formData.parentPhone,
              type: 1,
            })
            this.countDownTimes = 60
            timer = new Timer(this.countDownTimes)
            timer.start(this.$bus, COUNTDOWN)
            this.$bus.on(COUNTDOWN, countDownTimes => {
              this.countDownTimes = countDownTimes
            })
          } catch (error) {
            throw error
          }
        }
      })
    },
    handleClickChangeStep(type) {
      switch (type) {
        case 'increase':
          this.registerStep++
          break
        case 'reduce':
          this.registerStep--
          break
      }
    },
    handleClickRegister: _.throttle(async function() {
      console.log('this.formData', this.formData)
      if (!this.formData.clubName) {
        this.$message.error('请选择在读学校（学校）名称')
        return
      }
      if (!this.formData.picUrls[0] && !this.formData.picUrls[1]) {
        this.$message.error('请上传证件，个数2张！')
        return
      }
      if (
        this.formData.certificateState === 1 &&
        (!this.formData.certificatePicUrl[0] &&
        !this.formData.certificatePicUrl[1])
      ) {
        this.$message.error('请上传考级证书，至少1张！')
        return
      }
      if (!this.agreementFlag) {
        this.$message.error('请先阅读《国际象棋赛事用户协议》！')
        return
      }

      const { parentPhone: phone, code } = this.formData
      await authAPI.postCheckSmsCode({ phone, code, type: 1 })
      // if (!this.formData)
      this.$refs.formRef.validate(async (valid, object) => {
        if (valid) {
          let submitFormData = deepClone(this.formData)
          submitFormData.picUrls = submitFormData.picUrls.filter(url => url !== '').join(',')
          submitFormData.certificatePicUrl = submitFormData.certificatePicUrl.filter(url => url !== '').join(',')
          submitFormData.password = CryptoJS.enc.Base64.stringify(
            CryptoJS.enc.Utf8.parse(submitFormData.password),
          )
          const arr = submitFormData.cascaderCity.split('|')
          submitFormData.province = arr[0]
          submitFormData.city = arr[1]
          submitFormData.area = arr[2]
          delete submitFormData.cascaderCity
          const result = await authAPI.postUserRegister(submitFormData)
          switch (result.code) {
            case 0:
              this.registerStep++
              this.registerState = 2
              break
            case 10002:
              this.registerStep++
              this.registerState = 1
              break
            case -1:
              // this.registerState = 0
              this.$message.error(result.data)
              break
          }
        } else {
          const keys = Object.keys(object)
          this.$message.error(object[keys[0]][0].message)
          return false
        }
      })
    }),
    handleClickAgreement() {
      this.$refs.agreementRef.showAgreement = true
    },
  },
}
</script>

<style lang="scss" scoped>
.register-page {
  .title {
    margin-bottom: val(40);
  }
  &__register-box,
  &__register-result {
    margin: val(77) auto 0;
    width: val(1500);
    height: val(800);
    background-color: #fff;
    box-shadow: 0px 13px 35px rgba(0, 0, 0, 0.14);
    border-radius: val(15);
  }
  &__register-box {
    .register-box__left,
    .register-box__right {
      height: 100%;
      box-sizing: border-box;
    }
    .register-box__left {
      position: relative;
      padding: val(66) val(138) val(50) val(136);
      width: val(1108);
      background: url('../../../assets/images/auth/register-left-bg.png') no-repeat center;
      background-size: 100%;
      .form-item-row {
        display: flex;
        // justify-content: space-between;
        align-items: flex-end;
        &.attachment {
          margin-right: val(50);
          .el-form-item {
            // width: 100%;
            // display: flex;
            // align-items: center;
            &.no--border {
              ::v-deep .el-form-item__content {
                border: none;
              }
            }
            ::v-deep {
              .el-form-item__label {
                // margin-right: val(20);
                display: flex;
              }
              .el-form-item__content {
                display: block;
                .upload--attachment--list {
                  display: flex;
                  align-items: center;
                  width: 100%;
                  .attachment-uploader {
                    margin-right: val(20);
                  }
                }
              }
            }
            .tips {
              font-size: val(14);
              color: red;
            }
          }
          .icon-question {
            display: inline-block;
            width: val(16);
            vertical-align: middle;
            margin-left: val(4);
          }
          .attachment--certificate {
            &--upload {
              &__tips {
                width: val(140);
                margin-left: val(20);
                font-size: val(14);
                line-height: val(22);
                color: #d7d6d6;
              }
              ::v-deep .el-form-item__content {
                display: flex;
              }
            }
            .icon-question {
              margin: 0 val(6) 0 val(6);
            }
            .select--level {
              display: flex;
              align-items: center;
              margin-top: val(16);
              span {
                width: val(100);
                font-size: val(14);
                &:before {
                  content: '*';
                  color: #f56c6c;
                  margin-right: 4px;
                }
              }
              ::v-deep .el-select {
                .el-input__inner {
                  border-bottom: 1px solid rgba(180, 190, 215, 0.52);
                  border-radius: 0;
                }
              }
            }
          }
        }
        &.operation {
          justify-content: flex-end;
          margin-bottom: 0;
          .change-step {
            cursor: pointer;
            font-size: val(18);
            color: #0077e8;
            display: flex;
            align-items: center;
            .icon-back {
              margin-left: val(10);
              width: val(20);
              height: val(20);
              background: url('../../../assets/images/auth/back.png') no-repeat;
              background-size: 100%;
              &.rotate {
                transform: rotate(180deg);
              }
            }
          }
          &.first-step {
            left: 0;
            right: val(136);
            position: absolute;
            bottom: val(50);
          }
          &.second-step {
            margin-top: val(96);
          }
        }
        &.button {
          justify-content: center;
          margin-bottom: 0;
          .register-button {
            width: val(386);
            cursor: pointer;
          }
        }
        &.agreement {
          justify-content: center;
          .agreement-text {
            font-size: val(16);
            color: #5e3c00;
            .el-checkbox {
              margin-right: val(6);
            }
            span {
              cursor: pointer;
              color: #0077e8;
            }
          }
        }
        .el-form-item {
          margin-right: val(50);
          margin-bottom: 0;
          &:last-of-type {
            margin: 0;
          }
          &.club {
            ::v-deep {
              .el-form-item__content {
                border: none;
                .el-select {
                  border-bottom: 1px solid rgba(180, 190, 215, 0.52);
                  flex: 1;
                  .el-input {
                    border: none;
                    margin: 0;
                    width: unset;
                  }
                }
                .el-input {
                  width: val(133);
                  border-bottom: 1px solid rgba(180, 190, 215, 0.52);
                  margin-left: val(10);
                }
              }
            }
            .club__select {
              display: flex;
            }
          }
          &.password {
            ::v-deep .el-form-item__content {
              position: relative;
              padding-right: val(50);
              .security-level {
                position: absolute;
                right: 0;
                bottom: 0;
                padding-bottom: val(10);
                padding-right: val(13);
                font-size: val(16);
              }
            }
          }
          &.mobile {
            ::v-deep .el-form-item__content {
              position: relative;
              padding-right: val(120);
              .send-message {
                width: val(106);
                cursor: pointer;
                position: absolute;
                right: 0;
                bottom: 0;
                padding: 0 0 val(10) val(13);
                font-size: val(16);
                color: #0077e8;
                box-sizing: border-box;
                &:before {
                  content: '';
                  position: absolute;
                  left: 0;
                  top: val(2);
                  width: 1px;
                  height: val(12);
                  background: #b4bed7;
                  opacity: 0.52;
                }
              }
            }
          }
        }

      }
    }
    .register-box__right {
      width: val(392);
    }
  }

  &__register-result {
    background: url('../../../assets/images/auth/register-bg.png') #fff
      no-repeat;
    background-size: 100%;
    padding: val(66) 0 0 val(106);
    .register-result-main {
      display: flex;
      justify-content: center;
      .image-wrap {
        margin: 0 auto val(30);
      }
      .desc {
        text-align: center;
        margin-bottom: val(20);
        font-size: val(24);
        line-height: val(32);
        color: #5e3c00;
      }
      .options {
        display: flex;
        justify-content: center;
        .back--login {
          cursor: pointer;
          margin-right: val(40);
          font-size: val(16);
          line-height: val(21);
          color: #0077e8;
          &:last-of-type {
            margin-right: 0;
          }
        }
      }
      .success {
        padding-top: val(173);
        .image-wrap {
          width: val(373);
        }
      }
      .wait {
        padding-top: val(173);
        .image-wrap {
          width: val(210);
        }
      }
      .fail {
        padding-top: val(140);
        .image-wrap {
          width: val(265);
        }
      }
    }
  }
  .diy--label {
    display: flex;
    align-items: center;
  }
}
</style>
<style lang="scss">
.register-page {
  .form-item-row {
    margin-bottom: val(30);
    .el-form-item {
      width: val(244);
      margin: 0;
      .el-form-item__content {
        line-height: unset;
        float: left;
        width: 100%;
      }
      .el-cascader {
        width: 100%;
        line-height: unset;
      }
      .el-select {
        display: block;
        .el-input__prefix,
        .el-input__suffix {
          top: val(0);
          .el-input__icon {
            line-height: unset;
          }
        }
      }
      .el-icon-date {
        display: none;
      }

      .el-input {
        .el-input__inner {
          background-color: #fff;
          border: none;
          padding: 0;
          height: val(37);
          line-height: val(37);
          font-size: val(16);
          color: #111;
        }
      }
      .el-form-item__label {
        float: left;
        font-size: val(16);
        color: #5e3c00;
        line-height: 1em;
        vertical-align: unset;
        padding-bottom: val(12);
      }
      .el-form-item__content {
        border-bottom: 1px solid rgba(#b4bed7, 0.52);
      }
      .el-radio {
        display: flex;
        align-items: center;
        margin-right: val(10);
        &:last-of-type {
          margin: 0;
        }
        &__inner {
          width: 10px;
          height: 10px;
        }
        &__label {
          font-size: val(16);
          padding-left: val(6);
        }
      }
      &.avatar-form-item {
        display: flex;
        align-items: center;
        .el-form-item__label {
          padding: 0;
          margin-right: val(20);
        }
        .el-form-item__content {
          border-bottom: none;
          width: unset;
        }
        .avatar-uploader {
          .el-upload {
            display: block;
            border: 1px dashed rgba(#707070, 0.4);
            border-radius: 6px;
            cursor: pointer;
            position: relative;
            overflow: hidden;
            background: rgba(#F7F5EF, 0.4);
          }
          .avatar-uploader-icon {
            font-size: 28px;
            color: #C5C5C5;
            width: val(82);
            height: val(82);
            line-height: val(82);
            text-align: center;
          }
          .avatar {
            width: val(82);
            height: val(82);
            display: block;
          }
        }
      }
      &.attachment--certificate--upload {
        width: auto;
        .upload--attachment--list {
          width: auto !important;;
        }
      }
    }
  }
}
</style>
